import {
  ServiceabilityAccessType,
  ServiceabilityStatus,
  type CoreAccountsInterface,
} from '@brightside-web/desktop/feature/financial-accounts-core';

/** Base id for dev-injected external transfer accounts (avoids colliding with real accounts). */
export const DEV_MOCK_EXTERNAL_TRANSFER_ACCOUNT_ID_BASE = 900_001;

export interface DevMockExternalTransferAccountOptions {
  /** When true, sets serviceability.mustRepair for relink-modal testing. */
  readonly needsRelink?: boolean;
}

/**
 * Builds a fake external account for the transfer-funds account picker (dev menu only).
 */
export function createDevMockExternalTransferAccount(
  accountId: number,
  index = 0,
  options: DevMockExternalTransferAccountOptions = {}
): CoreAccountsInterface {
  const suffix = index > 0 ? ` ${index + 1}` : '';
  const needsRelink = options.needsRelink === true;

  return {
    availableBalance: 950.55,
    accountId,
    accountDisplayName: needsRelink
      ? `Dev External (Needs Relink)${suffix}`
      : `Dev External Checking${suffix}`,
    accountBalance: 1000,
    accountNumberMasked: 'XXXXXX7890',
    accountType: 'Checking' as CoreAccountsInterface['accountType'],
    isExternal: true,
    ...(needsRelink
      ? {
          serviceability: {
            status: ServiceabilityStatus.OPEN,
            accessType: ServiceabilityAccessType.FULL,
            isLocked: false,
            mustDelete: false,
            mustRepair: true,
          },
        }
      : {}),
  };
}
